module.exports = __webpack_public_path__ + "static/media/VitaminC – 1.fe351e83.jpg";